import React from "react";
import { View, Text, Image } from "react-native";
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import Dashboard from "./Dashboard";
import BorodatiSimple from "./BorodatiSimple";
import BorodatiPro from "./BorodatiPro";
import SelectDevice from "./SelectDevice";
import MenuNav from "./MenuNav";
import Icon from 'react-native-vector-icons/FontAwesome';
const Tab = createBottomTabNavigator();

const Home = props => {
    return (
        <Tab.Navigator screenOptions={{
            tabBarActiveTintColor: "#d12023",
            tabBarInactiveTintColor: '#898989',
            headerShown: true,
            tabBarLabelPosition: 'below-icon',
            tabBarStyle: {
                height: 70,
                margin: 10,
                marginBottom: 20,
                borderRadius: 10
            },
            tabBarLabelStyle: {
                fontFamily: 'IranSans',
                fontSize: 14,                
            },
            tabBarItemStyle: {
                backgroundColor: '#0b4660',
                margin: 5,
                borderRadius: 10,
            },
        }} >
            <Tab.Screen name='hometab' component={Dashboard} options={{
                tabBarLabel: 'خانه'
                , tabBarIcon: ({ size, color }) => (<Icon name={"home"} color={color} size={size} />)

            }} />
            <Tab.Screen name='calsimple' component={BorodatiSimple} options={{
                tabBarLabel: 'محاسبه ساده',
                tabBarIcon: (tabInfo) => (tabInfo.focused ? <Image resizeMode="contain" source={require("./../assets/icons/icon-simple-cal-click.png")} style={{ width: 50, height: 50 }} /> : <Image resizeMode="contain" source={require("./../assets/icons/icon-simple-cal.png")} style={{ width: 50, height: 50 }} />)
            }} />
            <Tab.Screen name='calpro' component={BorodatiPro} options={{
                tabBarLabel: 'محاسبه پیشرفته',
                tabBarIcon: (tabInfo) => (tabInfo.focused ? <Image resizeMode="contain" source={require("./../assets/icons/iconpro-cal-click.png")} style={{ width: 50, height: 50 }} /> : <Image resizeMode="contain" source={require("./../assets/icons/iconpro-cal.png")} style={{ width: 50, height: 50 }} />)
            }} />
            <Tab.Screen name='seldevice' component={SelectDevice} options={{
                tabBarLabel: 'انتخاب دستگاه',
                tabBarIcon: (tabInfo) => (tabInfo.focused ? <Image resizeMode="contain" source={require("./../assets/icons/icon-sel-device-click.png")} style={{ width: 50, height: 50 }} /> : <Image resizeMode="contain" source={require("./../assets/icons/icon-sel-device.png")} style={{ width: 50, height: 50 }} />)
            }} />
            <Tab.Screen name='navmenu' component={MenuNav} options={{
                tabBarLabel: 'درباره ما',
                tabBarIcon: ({ size, color }) => (<Icon name={"bars"} color={color} size={size} />)
            }} />

        </Tab.Navigator>
    )
}

export default Home; 